import React from "react";

const ReunionFooter = () => {
  return (
    <footer className="bg-gradient-to-b from-[#06251d] via-[#041b16] to-black border-t border-emerald-400/10 py-8 px-6">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-8">

        {/* Left */}
        <div className="lg:col-span-5">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="text-xl lg:text-2xl">🫂</span>
            <h2 className="text-lg lg:text-xl font-black tracking-tight text-white">
              Reunion
            </h2>
          </div>

          <p className="text-emerald-200 text-xs lg:text-sm leading-relaxed max-w-md">
            A PurpleDoor initiative by Think5Whys that transforms every gathering
            into an engaging live experience through community participation,
            celebration, friendly competition and memorable moments.
          </p>

          <div className="mt-4 text-xs lg:text-sm text-emerald-300">
            © 2026 Think5Whys. All rights reserved.
          </div>
        </div>

        {/* Center */}
        <div className="lg:col-span-3">
          <div className="uppercase tracking-[0.25em] text-sm lg:text-lg text-emerald-300 mb-4">
            Perfect For
          </div>

          <div className="space-y-2 text-emerald-200 text-xs lg:text-sm">
            <div>🏢 Housing Societies</div>
            <div>🏫 Schools & Colleges</div>
            <div>🎂 Birthdays & Anniversaries</div>
            <div>🏢 Corporate Events</div>
            <div>👨‍👩‍👧‍👦 Family & Friends Reunion</div>
            <div>🎉 Community Celebrations</div>
          </div>
        </div>

        {/* Right */}
        <div className="lg:col-span-4 flex flex-col justify-between">

          <div>
            <div className="uppercase tracking-[0.25em] text-xs text-emerald-300 mb-4">
              Our Vision
            </div>

            <h3 className="text-lg lg:text-xl font-bold text-white leading-snug mb-4">
              Every gathering deserves
              <br />
              unforgettable memories.
            </h3>

            <p className="text-emerald-200 text-xs lg:text-sm leading-relaxed">
              We believe every community event becomes more meaningful when
              people connect, participate, celebrate together and leave with
              lasting memories. Reunion makes every occasion interactive,
              inclusive and unforgettable.
            </p>
          </div>

          <div className="mt-4 text-emerald-300 text-sm lg:text-lg font-semibold">
            Celebrate • Connect • Compete 🫂
          </div>

        </div>

      </div>
    </footer>
  );
};

export default ReunionFooter;